import moment from 'moment';
import * as types from './types';

const INITIAL_STATE = {
  kitchenListLoading: false,
  kitchenListData: [],
  kitchenListLoadingError: null,
  availableKitchenDataLoading: false,
  availableKitchenData: [],
  availableKitchenDataError: null,
  toDateMin: moment(),
  fromDateMax: moment().add(1, 'month'),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_KITCHEN_LIST_LOADING:
      return { ...state, kitchenListLoading: action.payload };

    case types.KITCHEN_LIST_DATA:
      return { ...state, kitchenListData: action.payload };

    case types.FETCH_KITCHEN_LIST_LOADING_ERROR:
      return { ...state, kitchenListLoadingError: action.payload };

    case types.AVAILABLE_KITCHEN_PREP_WORKSHEET_LOADING:
      return { ...state, availableKitchenDataLoading: action.payload };

    case types.AVAILABLE_KITCHEN_PREP_WORKSHEET_DATA:
      return {
        ...state,
        availableKitchenData: action.payload,
      };

    case types.AVAILABLE_KITCHEN_PREP_WORKSHEET_FETCHING_ERROR:
      return { ...state, availableKitchenDataError: action.payload };

    case types.CLEAR_AVAILABLE_KITCHEN_ERROR:
      return {
        ...state,
        kitchenListLoadingError: null,
        availableKitchenDataError: null,
      };

    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };

    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };

    case types.RESET_DATE_RANGE:
      return {
        ...state,
        toDateMin: moment(),
        fromDateMax: moment().add(1, 'month'),
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/availableKitchenPrepWorksheet/reducer.js